import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/rightpanel/RightPanel.tsx");
